import useTypedSelector from '../../../common/hooks/useTypedSelector';
import { useEffect } from 'react';
import useThunkDispatch from '../../../common/hooks/useThunkDispatch';
import { clearCart, updateOrdersForProfile } from 'features/cart/CartSlice';

function OrderConfirmed() {
  const dispatch = useThunkDispatch();

  useEffect(() => {
    dispatch(clearCart());
    dispatch(updateOrdersForProfile());
  }, [dispatch]);

  const { email } = useTypedSelector((state) => ({
    email: state.profile.data.email,
  }));

  return (
    <div>
      <h2 className='cds-hero-heading'>Order Confirmed</h2>
      <p>Thank you for your order!</p>
      <p>
        A receipt will be emailed to{' '}
        <span style={{ textDecoration: 'underline' }}>{email}</span>
      </p>
    </div>
  );
}

export default OrderConfirmed;
